// src/App.js

import { Box, Container } from "@mui/material";
import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import LoadingSpinner from "./components/Common/LoadingSpinner";
import AutoScrollToTopOnRoute from "./components/Common/Scrolling/AutoScrollToTopOnRoute";
import BackToTop from "./components/Common/Scrolling/BackToTop";
import Layout from "./components/Layout/Layout";
import { UserContext } from "./contexts/UserContext";
import routes from "./routes";

const App = () => {
  const { loading } = useContext(UserContext);

  return (
    <Layout>
      <Container sx={{ flexGrow: 1, p: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              <AutoScrollToTopOnRoute />
              <BackToTop />
              <Routes>
                {routes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element} />
                ))}
              </Routes>
            </>
          )}
        </Box>
      </Container>
    </Layout>
  );
};

export default App;
